import React, { useEffect } from 'react';
import styles from './CaptureForm.module.scss';
import Select from 'component/atom/forms/select/select/Select';
import { useFormikContext } from 'formik';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import Input from 'component/atom/forms/input/input/Input';
import Button from 'component/atom/forms/button/Button';
import Toggle from 'component/atom/forms/toggle/Toggle';

const CaptureForm = ({ data, isFetching }) => {
  const formik = useFormikContext();

  useEffect(() => {
    if (data?.data?.items) {
      const selectedVariable = data?.data?.items.find(
        (item) => item.variableId == formik.values.variableId
      )?.variableName;

      formik.setFieldValue('variableLabel', selectedVariable || '');
    }
  }, [formik.values.variableId, data]);

  const typeOptions = data?.data?.items?.map((item) => ({
    value: item.variableId,
    label: item.variableName,
  }));

  return (
    <form
      className={styles['capture-form']}
      onSubmit={formik.handleSubmit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      }}
    >
      <Select
        label='Capture Variables'
        placeholder='Select Variables'
        options={typeOptions}
        name='variableId'
        value={formik.values.variableId}
        onChange={formik.handleChange}
        error={formik.errors.variableId}
        touched={formik.touched.variableId}
        isLoading={isFetching}
      />
      <div className={styles.border}></div>
      <div className={styles.suggest}>
        <p>Suggestions</p>
        <Toggle
          name='hasSuggestions'
          value={formik.values.hasSuggestions || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `hasSuggestions`,
              !formik.values.hasSuggestions
            );
          }}
        />
      </div>
      <div className={styles.border}></div>

      {formik?.values?.hasSuggestions ? (
        <>
          <div className={styles.suggest}>
            <p>AI Generated Question</p>
            <Toggle
              name='hasAIGenerated'
              value={formik.values.hasAIGenerated || false}
              onToggleChange={(e) => {
                formik.setFieldValue(
                  `hasAIGenerated`,
                  !formik.values.hasAIGenerated
                );
              }}
            />
          </div>
          {!formik?.values?.hasAIGenerated ? (
            <>
              {' '}
              <div className={styles['label-container']}>
                <p className={styles['label']}>Predefined Suggestions</p>
                {formik.values.suggestedQuestions?.length < 4 && (
                  <Button
                    type='plus'
                    transparent
                    buttonType='button'
                    onClick={() => {
                      formik.setFieldValue('suggestedQuestions', [
                        ...(formik.values.suggestedQuestions || []),
                        '',
                      ]);
                    }}
                    className={styles['button']}
                  />
                )}
              </div>
              {formik.values.suggestedQuestions.map((variant, index) => (
                <div className={styles['multi-input']} key={index}>
                  <Input
                    name={`suggestedQuestions.${index}.question`}
                    value={variant?.question}
                    onChange={formik.handleChange}
                    errors={
                      formik.errors?.suggestedQuestions?.[index]?.question
                    }
                    touched={
                      formik.touched?.suggestedQuestions?.[index]?.question
                    }
                    placeholder='Enter a question'
                    maxLength='30'
                  />
                  <div className={styles['variant-action']}>
                    <SvgWithBranding
                      type='delete_table'
                      className={styles.icon}
                      onClick={() => {
                        const updatedVariants =
                          formik.values.suggestedQuestions.filter(
                            (_, i) => i !== index
                          );
                        formik.setFieldValue(
                          'suggestedQuestions',
                          updatedVariants
                        );
                      }}
                    />
                  </div>
                </div>
              ))}
            </>
          ) : null}
        </>
      ) : null}
      {formik?.values?.hasSuggestions ? (
        <div className={styles.border}></div>
      ) : null}
      <div className={styles.suggest}>
        <p>Reassess Intent</p>
        <Toggle
          name='reassessIntent'
          value={formik.values.reassessIntent || false}
          onToggleChange={(e) => {
            formik.setFieldValue(
              `reassessIntent`,
              !formik.values.reassessIntent
            );
          }}
        />
      </div>
    </form>
  );
};

export default CaptureForm;
